/**
 * @file input 输入框组件
 */
import { Input as InnerInput } from './Input';
import { InputGroup } from './InputGroup';
export var Input = Object.assign(InnerInput, {
  Group: InputGroup
});